import type { Database } from '@/types/database'
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  // In production this will fail loudly on first auth call; during local dev
  // without a Supabase project yet, use placeholder values so the app renders.
  console.warn(
    'Missing Supabase env vars — auth calls will fail. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env.local.'
  )
}

export const supabase = createClient<Database>(supabaseUrl ?? '', supabaseAnonKey ?? '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// Anon-only client for reading public demo data — never attaches a user session.
// Used by SampleReportsPage so demo RLS policies can restrict to auth.uid() IS NULL.
export const anonSupabase = createClient<Database>(supabaseUrl ?? '', supabaseAnonKey ?? '', {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
  },
})
